module.exports = {
  template: require('./users-list-container.pug')()
  controller: require('./users-list-container.ctrl')
}
